<template>
  <a-modal
    title="公司信息"
    okText="编辑"
    @ok="save"
    v-model="visible"
    :width="650"
    class="showMessage"
  >
    <template v-if="!!companyInfo && !!companyInfo.report_data">
      <div class="listtitle">招聘信息</div>
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-col class="col">
          <span class="title"
            >最近一次成单职位：<span class="blue">{{
              companyInfo.report_data.latest_post.job_name || "-"
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >最近一次成单时间：{{
              companyInfo.report_data.latest_post.updated_at || "-"
            }}</span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >关联职位数：<span class="blue">{{
              companyInfo.report_data.job_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >招聘中职位数：<span class="blue">{{
              companyInfo.report_data.job_processing_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >接单数：<span class="blue">{{
              companyInfo.report_data.post_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >一面数：<span class="blue">{{
              companyInfo.report_data.interview_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >offer数：<span class="blue">{{
              companyInfo.report_data.offer_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >入职数：<span class="blue">{{
              companyInfo.report_data.entry_count
            }}</span></span
          >
        </a-col>
        <a-col class="col">
          <span class="title"
            >过保数：<span class="blue">{{
              companyInfo.report_data.complete_count
            }}</span></span
          >
        </a-col>
      </a-row>
      <div class="listtitle">基本信息</div>
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-col class="row">
          <span class="title">公司名称：{{ companyInfo.name }}</span>
        </a-col>
        <a-col class="row">
          <span class="title">公司简称：{{ companyInfo.short_name }}</span>
        </a-col>
        <a-col class="row">
          <span class="title">公司虚名：{{ companyInfo.full_name }}</span>
        </a-col>
        <a-col class="row">
          <span class="title">
            所属行业：{{ companyInfo.first_category_name }}/{{
              companyInfo.second_category_name
            }}
          </span>
        </a-col>
        <a-col class="row">
          <span class="title">公司规模：{{ companyInfo.scale_name }}</span>
        </a-col>
        <a-col class="row">
          <span class="title"
            >融资阶段：{{ companyInfo.financing_stage_name }}</span
          >
        </a-col>
        <a-col class="row">
          <span class="title">公司福利：{{ companyInfo.tags }}</span>
        </a-col>
        <a-col class="row">
          <span class="title">公司地址：{{ companyInfo.dist_name }}</span>
        </a-col>
        <a-col class="row">
          <span class="title">公司介绍：{{ companyInfo.introduction }}</span>
        </a-col>
      </a-row>
    </template>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "clientMessage",
  props: {
    companyInfo: {
      type: Object
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      visible: false
    };
  },
  mounted() {},
  methods: {
    save() {
      this.visible = false;
      this.callback && this.callback(this.companyInfo);
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.showMessage {
  .ant-modal-title {
    text-align: center;
  }
  .listtitle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .row-content {
    margin-left: 10px;
    .col {
      width: 50%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
    .row {
      width: 100%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
  }
  .blue {
    color: #35b5fe;
  }
}
</style>
